module.exports = __webpack_public_path__ + "static/media/logo_option4.19dd5abf.png";